import { HowTo, HowToStep, Thing, WithContext } from "schema-dts";

export const getHowToSchema = (howToData: WithContext<HowTo>): WithContext<HowTo> | null => {
    const steps = Array.isArray(howToData.step)
        ? howToData.step.map((step: Thing) => {
              const howToStep = step as HowToStep;
              return {
                  "@type": "HowToStep",
                  text: howToStep.text || ""
              };
          })
        : [];

    if (steps.length === 0) return null;

    return {
        "@context": "https://schema.org",
        "@type": "HowTo",
        name: howToData.name,
        step: steps as HowTo["step"]
    };
};